import { Banner, Typography, useDebounceValue } from '@neo4j-ndl/react';
import { PLAN_TYPE, consoleApi } from '@nx/state';
import { Page, SearchField } from '@nx/ui';
import { skipToken } from '@reduxjs/toolkit/query/react';
import { useMemo, useState } from 'react';

import { OrgList } from './orgs-list';

export const AllOrgs = () => {
  const [filter, setFilter] = useState('');
  const [debouncedFilter] = useDebounceValue(filter, 300);

  const { data: userDetails } = consoleApi.useGetUserDetailsQuery();
  const {
    data: organizations = [],
    isLoading,
    error,
  } = consoleApi.useListOrganizationsByUserQuery(userDetails?.id ?? skipToken);
  const isRemovePlanTypeRestriction = userDetails?.featureToggles['console-remove-plantype'] ?? false;
  const isEnterpriseUser = organizations.some((org) => org.planType === PLAN_TYPE.ENTERPRISE);

  const userOrgs = useMemo(() => {
    if (isEnterpriseUser && !isRemovePlanTypeRestriction) {
      return organizations.filter((org) => org.planType === PLAN_TYPE.ENTERPRISE);
    }
    return organizations;
  }, [isEnterpriseUser, isRemovePlanTypeRestriction, organizations]);

  return (
    <Page contentType="light">
      <Typography variant="h2">Your Organizations</Typography>
      <SearchField
        className="max-w-80"
        value={filter}
        onChange={(e) => setFilter(e.target.value)}
        htmlAttributes={{ 'aria-label': 'Search for organization' }}
      />
      {error ? (
        <Banner type="danger" title="API Error" description={JSON.stringify(error, null, 2)} isCloseable={false} />
      ) : (
        <OrgList orgs={userOrgs} filter={debouncedFilter} isLoading={isLoading} />
      )}
    </Page>
  );
};
